module.exports = __webpack_public_path__ + "static/media/report-disabled.488626f3.svg";